var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnswerKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_241_9654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33594 18.4C8.6766 18.4 8.11183 18.1648 7.6416 17.6943C7.17116 17.2241 6.93594 16.6593 6.93594 16C6.93594 15.3407 7.17116 14.7759 7.6416 14.3057C8.11183 13.8352 8.6766 13.6 9.33594 13.6C9.99527 13.6 10.56 13.8352 11.0303 14.3057C11.5007 14.7759 11.7359 15.3407 11.7359 16C11.7359 16.6593 11.5007 17.2241 11.0303 17.6943C10.56 18.1648 9.99527 18.4 9.33594 18.4ZM9.33594 24C7.11372 24 5.22483 23.2222 3.66927 21.6667C2.11372 20.1111 1.33594 18.2222 1.33594 16C1.33594 13.7778 2.11372 11.8889 3.66927 10.3333C5.22483 8.77778 7.11372 8 9.33594 8C10.8988 8 12.2822 8.37411 13.4859 9.12233C14.6897 9.87033 15.6397 10.9554 16.3359 12.3777H28.1583L32.0026 16.2223L26.2916 21.6223L23.4469 19.5333L20.6026 21.6223L17.9916 19.6223H16.3359C15.7286 20.9112 14.8267 21.963 13.6303 22.7777C12.434 23.5926 11.0026 24 9.33594 24ZM9.33594 21.7777C10.6099 21.7777 11.7674 21.3666 12.8083 20.5443C13.8489 19.7221 14.5248 18.674 14.8359 17.4H18.7583L20.6026 18.8557L23.4693 16.7777L26.0803 18.7667L28.8026 16.1777L27.2249 14.6H14.8359C14.5544 13.3851 13.9007 12.3518 12.8749 11.5C11.8489 10.6482 10.6693 10.2223 9.33594 10.2223C7.73594 10.2223 6.37294 10.7852 5.24694 11.911C4.12116 13.037 3.55827 14.4 3.55827 16C3.55827 17.6 4.12116 18.963 5.24694 20.089C6.37294 21.2148 7.73594 21.7777 9.33594 21.7777Z",
    fill: "#3F41D1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_241_9654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswerKey);
export default __webpack_public_path__ + "static/media/answer-key.e61f8de741e707051106789ba9fe9526.svg";
export { ForwardRef as ReactComponent };